import {number} from "yup";

export const checkIfaDateIsLongerThanANumberOfHours = (isoDate, hours) =>  {
    // Parse the ISO date to a JavaScript Date object
    const date = new Date(isoDate);

    // Get the current date and time
    const now = new Date();

    // Calculate the difference in milliseconds
    const difference = now.getTime() - date.getTime();

    // Convert hours to milliseconds
    const hoursInMilliseconds = hours * 60 * 60 * 1000;

    // Compare the difference with the number of hours in milliseconds
    return difference >= hoursInMilliseconds;
}

